/** Lichess-derived move accuracy: https://lichess.org/page/accuracy. Game aggregation is Chessla-specific. */
export const winProbability = (cp: number): number => 50 + 50 * (2 / (1 + Math.exp(-0.00368208 * cp)) - 1);

/** Before is mover-relative; after is next-mover-relative. Returns an estimated score, not a rating. */
export const moveAccuracy = (evalBeforeCp: number, evalAfterCp: number): number => {
  const wpBefore = winProbability(evalBeforeCp);
  const wpAfter = winProbability(-evalAfterCp);
  const drop = Math.max(0, wpBefore - wpAfter);
  return Math.max(0, Math.min(100, 103.1668 * Math.exp(-0.04354 * drop) - 3.1669));
};
